export default "/assets/webpack-assets/GT-Walsheim-Pro-Medium.5cbbabeb76691ce0046c07b2c6665315.woff";